/**
 * Advertising Optimization — primary navigation tab bar (FiasLeadsNav
 * mirror). Detail routes highlight their parent tab.
 */

import { Link, useLocation } from 'react-router-dom';
import {
  BarChart3,
  FlaskConical,
  Inbox,
  Megaphone,
  Link2,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import { ARCHE_PATH } from '../constants';

interface Tab {
  label: string;
  path: string;
  icon: LucideIcon;
  isActive: (pathname: string) => boolean;
}

export function AdoptNav() {
  const { pathname } = useLocation();

  const tabs: ReadonlyArray<Tab> = [
    {
      label: 'Dashboard',
      path: ARCHE_PATH,
      icon: BarChart3,
      isActive: (p) => p === ARCHE_PATH || p === `${ARCHE_PATH}/`,
    },
    {
      label: 'Campaigns',
      path: `${ARCHE_PATH}/campaigns`,
      icon: Megaphone,
      isActive: (p) => p.startsWith(`${ARCHE_PATH}/campaigns`),
    },
    {
      label: 'Experiments',
      path: `${ARCHE_PATH}/experiments`,
      icon: FlaskConical,
      isActive: (p) => p.startsWith(`${ARCHE_PATH}/experiments`),
    },
    {
      label: 'Inbox',
      path: `${ARCHE_PATH}/actions`,
      icon: Inbox,
      isActive: (p) => p.startsWith(`${ARCHE_PATH}/actions`),
    },
    {
      label: 'Links',
      path: `${ARCHE_PATH}/links`,
      icon: Link2,
      isActive: (p) => p.startsWith(`${ARCHE_PATH}/links`),
    },
    {
      label: 'Settings',
      path: `${ARCHE_PATH}/settings`,
      icon: Settings,
      isActive: (p) => p.startsWith(`${ARCHE_PATH}/settings`),
    },
  ];

  return (
    <nav className="flex items-center gap-1 border-b border-border px-4 overflow-x-auto">
      {tabs.map((tab) => {
        const active = tab.isActive(pathname);
        const Icon = tab.icon;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 whitespace-nowrap transition-colors ${
              active
                ? 'border-primary text-foreground font-medium'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon className="h-4 w-4" />
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
